import { Component, Input, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IPolicyAsset } from 'src/app/modules/shared/models/policy.model';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { INVESTMENT_ASSETS_TABLE_TABLE_KEYS } from './branch-switch-investment.constants';

@Component({
  selector: 'app-branch-switch-investment',
  templateUrl: './branch-switch-investment.component.html',
  styleUrl: './branch-switch-investment.component.scss',
})
export class BranchSwitchInvestmentComponent implements OnDestroy {

  @Input() assets: IPolicyAsset[] = [];
  @Input() policyFunds: IPolicyAsset[] = [];
  @Input() form: FormGroup;
  @Input() isReadOnly: boolean;
  tableKeys: ITableKey[] = CommonUtils.assign(INVESTMENT_ASSETS_TABLE_TABLE_KEYS);
  destroy$ = new Subject();

  get showFunds(): boolean {
    return this.assets && this.assets.length > 0;
  }

  get totalDivestmentAmount(): number {
    const value = this.policyFunds.reduce((acc, fund) => {
      let amount = fund?.amount;
      amount = amount.replace(/\./g, '');
      amount = amount.replace(',', '.'); 
      return acc + parseFloat(amount);
    }, 0);
    return value;
  }

  get totalInvestmentAmount(): number {
    const value = this.form?.get('amount')?.value ?? '0,00';
    return value;
  }

  get divestedFunds(): string[] {
    const array = this.policyFunds
      .filter((fund: IPolicyAsset) => fund.fundCode && parseFloat(String(fund.amount)?.replace(',', '.')) > 0)
      .map((fund: IPolicyAsset) => fund.fundCode);
    return array;
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
